export default function calcBaseSize(base64String) {
    // Source: https://stackoverflow.com/a/47852494
    let base64Length = base64String.length - (base64String.indexOf(",") + 1);
    let padding = (base64String.charAt(base64String.length - 2) === "=") ? 2 : ((base64String.charAt(base64String.length - 1) === "=") ? 1 : 0);
    let fileSize = base64Length * 0.75 - padding;
    return fileSize;
}